export default __webpack_public_path__ + "static/media/MG.c287eed1.svg";